export default "__VITE_ASSET__C34uqqMr__"